<template>
  <div>
    <div id='printReady' v-show='widgetLoaded'></div>
    <DashboardGrid :widgets="widgets" :col_num="4" :print="true"/>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import DashboardGrid from '@/views/DashboardGrid'


import moment from 'moment'
export default {
  name: 'PrintWidget',
  components: {
    DashboardGrid
  },
  data: function() {
    return {
      widgets: []
    }
  },
  created () {
    if (this.$route.query.start_date) {
      this.setStartDate(moment(this.$route.query.start_date))
      this.setEndDate(moment(this.$route.query.end_date))
    }
    if (this.$route.query.compare_start_date && this.$route.query.compare_end_date) {
      this.setCompareStartDate(moment(this.$route.query.compare_start_date))
      this.setCompareEndDate(moment(this.$route.query.compare_end_date))
    }
    this.setCurrentClient({id: parseInt(this.$route.query.client), domain: this.$route.query.client_domain})
    this.loadWidget(this.$route.params.id)
  },
  methods: {
    ...mapMutations([
      'setCurrentClient',
      'setStartDate',
      'setEndDate',
      'setCompareStartDate',
      'setCompareEndDate'
    ]),

    loadWidget (widgetId) {
      let params = { params: {} }
      this.$http.get(`/widgets/${widgetId}`, params)
        .then(response => this.showWidgets(response))
        .catch((e) => console.log(e))
    },

    showWidgets (response) {
      this.widgets = []
      let widget = response.data.data
      this.$nextTick(() => {
        this.widgets.splice(1,0,{
          id: parseInt(widget.id, 10),
          title: widget.attributes.title,
          widget_titles: widget.attributes.widget_titles.map((title) => title.title),
          type: widget.attributes.widget_type + 'Widget',
          dashboard_id: this.$route.params.id,
          audits: widget.attributes.audits,
          x: widget.attributes.grid_position.x,
          y: widget.attributes.grid_position.y,
          w: widget.attributes.grid_position.w,
          h: widget.attributes.grid_position.h,
          shared: widget.attributes.shared,
          filters: widget.attributes.filters,
          options: widget.attributes.options,
          owner_id: widget.attributes.owner_id,
          locked: widget.attributes.locked,
          disable_legend: widget.attributes.disable_lengend,
          disableDataComparison: widget.attributes.disable_data_comparison,
          sectionIds: widget.attributes.section_ids,
          stacked_barchart: widget.attributes.data.stacked_barchart
        })
      })
    },

  },
  props: [
    'start_date',
    'end_date',
    'compare_start_date',
    'compare_end_date'
  ],

  computed: {
    ...mapGetters(['dashboardData']),
    widgetLoaded: function () {
      if (this.dashboardData.length > 0 && this.dashboardData.length == this.dashboardData.filter( w =>  w.data.length > 0).length) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
